export default __webpack_public_path__ + "static/media/bg-masthead-2-320w.df09abd8.webp";